export default [
  'US',
  'PH',
  'CA',
  'AU',
  'NZ',
  'GB',
  'IE',
  'MY',
  'IN',
  'PK',
  'NG',
  'KE',
];
